import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";

type HandlerType = Handler<any, any>;

export const DeleteLocalStorage: HandlerType = props => {
    window?.localStorage?.removeItem("selectedWarehouseForInventory");
};

addToChainAfter(chain, DeleteSession, DeleteLocalStorage);
